appShouldRender